import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout puro de /m/master/workspaces — apenas Outlet pra permitir que
 * a rota filha /m/master/workspaces/$id renderize. A lista em si está
 * em m.master.workspaces.index.tsx.
 */
export const Route = createFileRoute('/m/master/workspaces')({
  component: WorkspacesLayout,
});

function WorkspacesLayout() {
  return <Outlet />;
}
